/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Factual_Spare_Parakeet_GulpInputs */

const fr_factual_spare_parakeet_gulp = /** @type {(inputs: Factual_Spare_Parakeet_GulpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine précédente`)
};

/**

* @param {Factual_Spare_Parakeet_GulpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const factual_spare_parakeet_gulp = /** @type {((inputs?: Factual_Spare_Parakeet_GulpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Factual_Spare_Parakeet_GulpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_factual_spare_parakeet_gulp(inputs)
});